import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>West Bengal Guide</p>
      </header>
    </div>
  );
}

export default App;
